
import Vue from "vue";
import Component from "vue-class-component";
import {ApplicationsListClient, SeafarerApplicationLightViewModel} from "@/api-client";
import {Prop} from "vue-property-decorator";
import SeafarerDashboardApplicationTable from "@/features/dashboard/components/SeafarerDashboardApplicationTable.vue";
import PopoverInfo from '@/components/PopoverInfo.vue';

@Component({
    components: {
        SeafarerDashboardApplicationTable,
        PopoverInfo
    }
})
export default class BaseDocumentApplicationUsageWidget extends Vue {
    @Prop({required: true})
    usedInApplicationIds!: string[];
    
    usedInApplications: SeafarerApplicationLightViewModel[] | null = null;

    async created() {
        if (this.usedInApplicationIds?.length) {
            new ApplicationsListClient()
                .seafarer(this.usedInApplicationIds)
                .then(x => { this.usedInApplications = x })
        } else {
            this.usedInApplications = [];
        }
    }

    get isLoading(): boolean {
        return !!this.usedInApplications;
    }
}
